import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { PickId, V1PickId, V2OptionMarketPickId } from '../../core/picks/pick-id';

export interface ILineSwitcherPickHandlerService {
    pickSelected$(id: V1PickId | V2OptionMarketPickId): Observable<boolean>;
    swap(pickId: V1PickId | V2OptionMarketPickId): void;
    readonly currentPick$: Observable<PickId>;
}

export const BETSLIP_LINE_SWITCHER_INJECTION_TOKEN = new InjectionToken<ILineSwitcherPickHandlerService>('BETSLIP_LINE_SWITCHER_INJECTION_TOKEN');
